const authErrorHashPattern = /^#error=(login_required|interaction_required|temporarily_unavailable|access_denied)(?:&|$)/;
const authCallbackHashPattern = /^#(?:state|session_state|code)=/;
const authCallbackQueryPattern = /(?:^|[?&])(state|session_state|code)=/;

export function removeAuthErrorHashFromCurrentUrl(): void {
  if (!authErrorHashPattern.test(window.location.hash)) {
    return;
  }

  history.replaceState(null, document.title, window.location.pathname + window.location.search);
}

export function hasAuthErrorHash(): boolean {
  return authErrorHashPattern.test(window.location.hash);
}

export function hasAuthCallbackParams(): boolean {
  return authCallbackHashPattern.test(window.location.hash)
    || authCallbackQueryPattern.test(window.location.search);
}

export function getCleanCurrentUrl(): string {
  if (authErrorHashPattern.test(window.location.hash)) {
    return window.location.origin + window.location.pathname + window.location.search;
  }

  return window.location.href;
}

export function getCleanRedirectUri(pathAndQuery: string): string {
  const [pathWithoutFragment] = pathAndQuery.split('#');
  return window.location.origin + pathWithoutFragment;
}
